/* eslint-disable react/no-unknown-property */
import React, { useState } from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosTipos.css';
import CustomEmblaCarousel from '../../organisms/CustomEmblaCarousel';
import { isMobile } from '@/utils/browser';

function CarrosEletricosTipos() {
  const [type, setType] = useState(0);

  return (
    <>
      <section id="carros-eletricos-type">
        <Container>
          <div className="carros-eletricos-type-div-btns">
            <span
              className={`carros-eletricos-type-btn ${type === 0 ? 'selected' : ''}`}
              onClick={() => setType(0)}
            >
              Híbridos
            </span>
            <span
              className={`carros-eletricos-type-btn ${type === 1 ? 'selected' : ''}`}
              onClick={() => setType(1)}
            >
              100% Elétricos
            </span>
          </div>
          <div className="carros-eletricos-type-details-div">
            {type === 0 ? (
              <>
                <p className="carros-eletricos-type-details-text">
                  Os <b>Carros Híbridos</b> podem ser divididos entre PHEV e HEV, em que a primeira
                  categoria pode ser carregada na tomada e é possível optar entre a energia e o
                  combustível.
                  <br /> A segunda categoria consiste em veículos à combustão que geram energia para
                  carregar as baterias.
                </p>
                <picture>
                  <source type="image/webp" srcSet="assets/carros-eletricos/carro-hibrido.webp" />
                  <source type="image/png" srcSet="assets/carros-eletricos/carro-hibrido.png" />
                  <img
                    className="carros-eletricos-type-details-img"
                    src="assets/carros-eletricos/carro-hibrido.png"
                    alt="veículos eletricos"
                  />
                </picture>
              </>
            ) : (
              <>
                <p className="carros-eletricos-type-details-text carros-eletricos-type-details-text-p2">
                  Chamados de BEV, os carros e <b>motos elétricas</b> são extremamente ecológicos,
                  já que emitem zero CO2 durante a condução do veículo e também possuem um preço
                  reduzido durante o uso, já que o uso de energia é mais econômico do que o
                  combustível.
                </p>
                <picture>
                  <source type="image/webp" srcSet="assets/carros-eletricos/carro.webp" />
                  <source type="image/png" srcSet="assets/carros-eletricos/carro.png" />
                  <img
                    className="carros-eletricos-type-details-img"
                    src="assets/carros-eletricos/carro.png"
                    alt="veículos eletricos"
                  />
                </picture>
              </>
            )}

            {/* <img
              className="carros-eletricos-type-details-img"
              src="assets/carros-eletricos/carro.png"
              alt="veículos eletricos"
            /> */}
            <div className="carros-eletricos-type-details-circles-mb" />
            <div className="carros-eletricos-type-details-circles-ds" />
          </div>
        </Container>
        <div className="carros-eletricos-type-carousel">
          <Container>
            <h3 className="carros-eletricos-type-carousel-title">
              Vantagens dos <b>veículos elétricos</b>
            </h3>
            <div className="carros-eletricos-type-carousel-ctn">
              <CustomEmblaCarousel
                enableBullets
                bulletCount={6}
                options={{ slidesToScroll: isMobile() ? 1 : 3 }}
                hideOverflow
                enablePrevArrow
              >
                {({ className }) => (
                  <>
                    <div className={`slide carros-eletricos-type-slide ${className}`}>
                      <div className="carros-eletricos-type-slide-ctn">
                        <div className="carros-eletricos-type-slide-img">
                          <img src="assets/carros-eletricos/icon-plant.svg" alt="ícone de planta" />
                        </div>
                        <p className="carros-eletricos-type-slide-txt">Menos poluente</p>
                      </div>
                    </div>
                    <div className={`slide carros-eletricos-type-slide ${className}`}>
                      <div className="carros-eletricos-type-slide-ctn">
                        <div className="carros-eletricos-type-slide-img">
                          <img
                            src="assets/carros-eletricos/ic_audio_on.svg"
                            alt="ícone de sirene"
                          />
                        </div>
                        <p className="carros-eletricos-type-slide-txt">Mais silencioso </p>
                      </div>
                    </div>
                    <div className={`slide carros-eletricos-type-slide ${className}`}>
                      <div className="carros-eletricos-type-slide-ctn">
                        <div className="carros-eletricos-type-slide-img">
                          <img
                            src="assets/carros-eletricos/ic_levy_received.svg"
                            alt="ícone de parceria"
                          />
                        </div>
                        <p className="carros-eletricos-type-slide-txt">
                          Menor custo <br />
                          com impostos
                        </p>
                      </div>
                    </div>
                    <div className={`slide carros-eletricos-type-slide ${className}`}>
                      <div className="carros-eletricos-type-slide-ctn">
                        <div className="carros-eletricos-type-slide-img">
                          <img
                            src="assets/carros-eletricos/icon-gas-bomb.svg"
                            alt="ícone de recarga para o veículo"
                          />
                        </div>
                        <p className="carros-eletricos-type-slide-txt">
                          Menor custo de abastecimento
                        </p>
                      </div>
                    </div>
                    <div className={`slide carros-eletricos-type-slide ${className}`}>
                      <div className="carros-eletricos-type-slide-ctn">
                        <div className="carros-eletricos-type-slide-img">
                          <img
                            src="assets/carros-eletricos/icon-spanner.svg"
                            alt="ícone de ferramenta"
                          />
                        </div>
                        <p className="carros-eletricos-type-slide-txt">Menor custo de manutenção</p>
                      </div>
                    </div>
                    <div className={`slide carros-eletricos-type-slide ${className}`}>
                      <div className="carros-eletricos-type-slide-ctn">
                        <div className="carros-eletricos-type-slide-img">
                          <img
                            src="assets/carros-eletricos/icon-energy.svg"
                            alt="ícone de energia"
                          />
                        </div>
                        <p className="carros-eletricos-type-slide-txt">
                          90% mais eficientes no consumo de energia
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </CustomEmblaCarousel>
            </div>
          </Container>
        </div>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosTipos;
